module.exports = __webpack_public_path__ + "img/camara.e30661b7.png";